import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { opacityBackgroundCss } from '../backgrounds'
import { ColorsSchemeNames } from '../colors'
import { TransitionCoreProps } from './lib/types'

export const TransitionCore = forwardRef<HTMLDivElement, TransitionCoreProps>(
	({ state, styles, children, bgColor, bgImage, className }, ref) => {
		return (
			<Wrapper
				ref={ref}
				style={styles?.[state]}
				bgColor={bgColor as ColorsSchemeNames}
				bgImage={bgImage}
				className={className}
			>
				{children}
			</Wrapper>
		)
	}
)

const Wrapper = styled.div`
	${opacityBackgroundCss}
`
